import React, { PropsWithChildren } from "react";

const StopPropagation = ({ children }: PropsWithChildren<{}>) => {
    return <span onClick={(e) => e.stopPropagation()}>{children}</span>;
};

export default StopPropagation;
